"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//tslint:disable-next-line
var AppInsights = require('applicationinsights-js').AppInsights;
if (window.instrumentationKey) {
    AppInsights.downloadAndSetup({ instrumentationKey: window.instrumentationKey });
}
var _app = { name: 'unknown', version: 'unknown' };
function initialize(app) {
    _app = app;
}
exports.initialize = initialize;
function trackEvent(name, properties) {
    if (window.instrumentationKey) {
        AppInsights.trackEvent(name, __assign(__assign({}, _app), properties));
    }
}
exports.trackEvent = trackEvent;
//# sourceMappingURL=analytics.js.map